import React, { Component } from 'react';
import { Card, Form, Button, Alert, Row, Col, Container } from "react-bootstrap";
import axios from "axios";
import CommonLoader from '../loaderComponent/CommonLoader';
import { validateAddRoleForm } from '../../utils/validation';
import CommonToast from '../Toaster/CommonToast';

export default class AddRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      hasError: false,
      errMsg: "",
      completed: false,
      loading: true,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false })
    }, 900)
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  onSubmit = async (e) => {
    this.setState({ loading: true })
    e.preventDefault();
    const { name } = this.state;
    const token = localStorage.getItem("token");
    const errors = validateAddRoleForm(
      this.state.name
    );
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in." });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    const roleData = { name };
    console.log("roleData", roleData);
    try {
      await axios.post('/role', roleData, { headers });
      this.setState({
        toastMessage: "Role created successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/role-list");
      }, 900);

    } catch (error) {
      console.error("Error adding role:", error);
      let errorMessage = "Failed to add role.";

      if (error.response) {
        if (error.response.status === 400) {
          errorMessage = error.response.data.err;
        } else if (error.response.status === 403) {
          errorMessage = "Access Denied! Admin privileges required.";
        }
      }
      this.setState({
        hasError: true,
        errMsg: errorMessage,
        toastMessage: errorMessage,
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
    }
  };
  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/role-list");
      this.setState({ loading: false });
    }, 500);
  }
  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <CommonLoader isLoading={this.state.loading}>
          <Container className="pt-4">
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>Add Role</strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  <Row className="mb-3">
                    <Col xs={12} md={6} lg={4}>
                      <Form.Group>
                        <Form.Label className="text-muted required"> Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder='Enter role name'
                          value={this.state.name}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.name && <small className="text-danger">{this.state.errors.name}</small>}
                      </span>
                    </Col>
                  </Row>
                  <div className='add-cancel-btn '>
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                      Add
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Container>
        </CommonLoader>
      </>
    );
  }
}
